import script from "./EditNoteView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditNoteView.vue?vue&type=script&setup=true&lang=ts"

import "./EditNoteView.vue?vue&type=style&index=0&id=b07622f2&lang=scss"

const __exports__ = script;

export default __exports__